import type { TDeviceType } from '@cian/ui-kit';

import { SOCIAL_ICON_BY_ID, SOCIAL_ICON_PHONE_BY_ID } from 'shared/constants/socials';
import type { IMappedSocialLink, TRemoteSocial } from 'shared/types/socials';

const isRemoteSocialList = (value: unknown): value is TRemoteSocial[] => {
  return (
    Array.isArray(value) &&
    value.every(item => {
      if (!item || typeof item !== 'object') {
        return false;
      }

      const { id, href } = item;

      return typeof id === 'string' && id in SOCIAL_ICON_BY_ID && typeof href === 'string';
    })
  );
};

export const mapRemoteSocials = (
  data: TRemoteSocial[] | null | undefined,
  device?: TDeviceType,
): IMappedSocialLink[] => {
  if (!isRemoteSocialList(data)) {
    return [];
  }

  const iconById = device === 'phone' ? SOCIAL_ICON_PHONE_BY_ID : SOCIAL_ICON_BY_ID;

  return data.map(({ id, href }) => ({
    id,
    href,
    Icon: iconById[id],
  }));
};
